module.exports = __webpack_public_path__ + "img/p65-honghe-2018.74524c62.jpg";